import { BorderColor, FindInPage, LocalShipping, SupervisedUserCircle } from '@mui/icons-material';
import { ReactElement } from 'react';
import { Resources } from '../auth/authTypes';

interface Tab {
  label: string;
  href: string;
  icon: ReactElement;
  event: string;
}

export const TabsData: { [key in Resources]: Tab } = {
  [Resources.eTRF]: { label: 'Order test', href: '/orders/new', icon: <BorderColor />, event: 'order_test' },
  [Resources.ordersListView]: {
    label: 'Orders & results',
    href: '/orders',
    icon: <FindInPage />,
    event: 'view_orders_results',
  },
  [Resources.kitOrdering]: { label: 'Request kits', href: '/kits/new', icon: <LocalShipping />, event: 'request_kits' },
  [Resources.users]: {
    label: 'Users & permissions',
    href: '/users_and_permissions',
    icon: <SupervisedUserCircle />,
    event: 'users_and_permissions',
  },
};

export const contactSupport = (type: 'phone' | 'email' | 'fax' | 'address') => {
  switch (type) {
    case 'phone':
      window.location.href = 'tel:18664527487';
      return;
    case 'email':
      window.location.href = 'mailto:help@kariusdx.com';
      return;
    case 'fax':
      navigator.clipboard.writeText('866-246-6567');
      return;
    case 'address':
      navigator.clipboard.writeText(
        `Karius Inc.
975 Island Drive, Suite 101
Redwood City, CA 94065`,
      );
      return;
  }
};
